import { render, staticRenderFns } from "./RowHeaderItem.vue?vue&type=template&id=596d731c&"
import script from "./RowHeaderItem.vue?vue&type=script&lang=js&"
export * from "./RowHeaderItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports